var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-legenda"},[_c('div',{staticClass:"titulo-legenda"},[_vm._v(_vm._s(_vm.titulo)+":")]),_vm._l((_vm.itens),function(item){return _c('div',{staticClass:"item-legenda"},[_c('div',{staticClass:"icone-legenda",style:(item.estilo)}),_c('div',{staticClass:"texto-legenda"},[_vm._v(_vm._s(item.texto))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }